import React from "react";
import { Redirect, Route, Switch } from "react-router";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { Container } from "react-bootstrap";
import { RouteEndpoints, Routes } from "../services/route.service";
import {CheckContentProviderIdExist} from "../services/app.service";
import {useSelector} from "react-redux";
import {IRootState} from "../redux/states";

function DashboardLayout() {
  const triggerSidebar = () => {
    // @ts-ignore
    const sidebar = document.querySelector(".iq-sidebar");

    // @ts-ignore
    sidebar.classList.toggle("show");
  };

  return (
    <>
      <div className="position-relative">
        <div className="wrapper">
          <Sidebar triggerSidebar={triggerSidebar} />

          <div id="content-page" style={{ overflow: "hidden" }}>
            <TransitionGroup>
              <CSSTransition classNames="fadeUp" timeout={300}>
                <div className="dashboard-layout overflow-hidden lg">
                {/*<Container className="dashboard-layout overflow-hidden lg">*/}
                  <Header triggerSidebar={triggerSidebar} />
                  <div
                    style={{
                      overflowY: "scroll",
                      overflowX: "hidden",
                      height: "100%",
                      maxHeight: "90vh",
                    }}
                    className={"scroller-hide"}
                  >
                    <Switch>
                      {Routes.map((route, i) =>
                        route.private ? (
                          <Route
                            key={i}
                            exact={route.exact}
                            path={route.path}
                            render={(props) => <route.component {...props} />}
                          />
                        ) : (
                          !route.private &&
                          // route.path === RouteEndpoints.SIGN_IN && (
                          route.path === RouteEndpoints.UNAUTH_HOME && (
                            <Route
                              key={i}
                              exact={route.exact}
                              path={route.path}
                              render={(props) => <route.component {...props} />}
                            />
                          )
                        )
                      )}
                      <Redirect to={{ pathname: RouteEndpoints.HOME }} />
                    </Switch>
                  </div>
                {/*</Container>*/}
                </div>
              </CSSTransition>
            </TransitionGroup>
            {/* <Footer /> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardLayout;
